import getOrderState from './getOrderState';
import getRouteState from './getRouteState';
import getCourierPosition from './getCourierPosition';
import sendFeedback from './sendFeedback';

export default { getOrderState, getRouteState, getCourierPosition, sendFeedback };
